module.exports = __webpack_public_path__ + "img/target-ratio-success.2ba107ea.png";